import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { IoEyeSharp } from "react-icons/io5";
import { FaEyeSlash } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";



const UserDialog = ({
	open,
	handleClose,
	handleTextFieldChange,
	handleEmail,
	handleMobile,
	handlePassword,
	handleChange,
	createUser,
	newUser,
	error,
	action,
	roles,
	role,
	dialogTitle,
	alertMessage,
}) => {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<AnimatePresence>
			{open && (
				<motion.div
					className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 backdrop-blur-sm px-4"
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
				>
					<motion.div
						initial={{ opacity: 0, y: 24, scale: 0.96 }}
						animate={{ opacity: 1, y: 0, scale: 1 }}
						exit={{ opacity: 0, y: 14, scale: 0.98 }}
						transition={{ duration: 0.22, ease: "easeOut" }}
						className="w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden relative border border-transparent backdrop-blur-md"
						style={{
							background:
								"linear-gradient(155deg, rgba(8, 17, 36, 0.95) 0%, rgba(18, 32, 62, 0.88) 100%) padding-box, linear-gradient(125deg, rgba(56, 189, 248, 0.85) 0%, rgba(59, 130, 246, 0.85) 45%, rgba(99, 102, 241, 0.85) 100%) border-box",
						}}
					>
						<div className="h-1 bg-gradient-to-r from-indigo-500 via-blue-500 to-cyan-500" />

						<div className="px-5 py-4 border-b border-white/15 bg-white/5 relative text-center">
							<div className="mx-auto">
								<span
									className="inline-block text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full text-white"
									style={{ backgroundImage: "linear-gradient(90deg, #4f46e5 0%, #2563eb 100%)" }}
								>
									{action === "Add" ? "Create" : "Edit"}
								</span>
								<h2 className="text-lg font-extrabold text-white mt-1.5">
									{dialogTitle}
								</h2>
								<p
									className="text-xs mt-1 inline-block px-2.5 py-1 rounded-md border text-white shadow-sm font-semibold"
									style={{
										borderColor: "rgba(255,255,255,0.35)",
										backgroundImage: "linear-gradient(90deg, rgba(6,182,212,0.95) 0%, rgba(37,99,235,0.95) 100%)",
									}}
								>
									{action === "Add" ? "Create a new user profile" : "Modify user details"}
								</p>
							</div>
							<button
								onClick={handleClose}
								className="absolute top-3.5 right-4 h-8 w-8 rounded-full text-white grid place-items-center shadow-sm hover:brightness-105 transition"
								style={{ backgroundImage: "linear-gradient(90deg, #6366f1 0%, #2563eb 100%)" }}
								aria-label="Close dialog"
							>
								<RxCross2 size={18} />
							</button>
						</div>

						{alertMessage && (
							<div className="mx-5 mt-3 px-3 py-1.5 rounded-lg border border-rose-300/50 bg-rose-500/15 text-sm text-rose-100">
								{alertMessage}
							</div>
						)}

						<div className="p-5 bg-white/[0.03]">
							<form className="space-y-3">
								<div className="grid grid-cols-1 md:grid-cols-2 gap-2.5">
									<div>
										<label className="text-xs font-semibold uppercase tracking-wide text-white mb-0.5 block">
											User Name
										</label>
										<input
											type="text"
											id="user_name"
											value={newUser.user_name}
											onChange={handleTextFieldChange}
											placeholder="User Name"
											className="w-full h-10 px-3.5 py-2 border border-slate-200/80 rounded-lg bg-white/95 text-slate-900 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-cyan-300"
										/>
										{error.user_error && (
											<p className="text-xs text-rose-200 mt-1">{error.user_error}</p>
										)}
									</div>

									<div>
										<label className="text-xs font-semibold uppercase tracking-wide text-white mb-0.5 block">
											Email
										</label>
										<input
											type="email"
											id="user_email"
											value={newUser.user_email}
											onChange={handleEmail}
											placeholder="User Email"
											className="w-full h-10 px-3.5 py-2 border border-slate-200/80 rounded-lg bg-white/95 text-slate-900 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-cyan-300"
										/>
										{error.email_error && (
											<p className="text-xs text-rose-200 mt-1">{error.email_error}</p>
										)}
									</div>

									<div>
										<label className="text-xs font-semibold uppercase tracking-wide text-white mb-0.5 block">
											Mobile Number
										</label>
										<input
											type="text"
											id="mobile_no"
											value={newUser.mobile_no}
											onChange={handleMobile}
											placeholder="Mobile Number"
											className="w-full h-10 px-3.5 py-2 border border-slate-200/80 rounded-lg bg-white/95 text-slate-900 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-cyan-300"
										/>
										{error.mobile_error && (
											<p className="text-xs text-rose-200 mt-1">{error.mobile_error}</p>
										)}
									</div>

									<div className="relative">
										<label className="text-xs font-semibold uppercase tracking-wide text-white mb-0.5 block">
											Password
										</label>
										<input
											type={showPassword ? "text" : "password"}
											id="password"
											value={newUser.password}
											onChange={handlePassword}
											placeholder="Password"
											className="w-full h-10 px-3.5 py-2 pr-10 border border-slate-200/80 rounded-lg bg-white/95 text-slate-900 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-cyan-300"
										/>
										<button
											type="button"
											onClick={() => setShowPassword(!showPassword)}
											className="absolute inset-y-0 right-0 w-10 rounded-r-lg border-l border-slate-300 bg-slate-100 flex items-center justify-center text-slate-700 hover:text-indigo-600"
										>
											{showPassword ? <FaEyeSlash className="h-4 w-4" /> : <IoEyeSharp className="h-4 w-4" />}
										</button>
										{error.password_error && (
											<p className="text-xs text-rose-200 mt-1">{error.password_error}</p>
										)}
									</div>
								</div>

								<div>
									<label className="text-xs font-semibold uppercase tracking-wide text-white mb-0.5 block">
										Role
									</label>
									<select
										id="user_roleid"
										value={role}
										onChange={handleChange}
										className="w-full h-10 px-3.5 py-2 text-sm border border-slate-200/80 rounded-lg bg-white/95 text-slate-900 focus:outline-none focus:ring-2 focus:ring-cyan-300"
									>
										<option value="" disabled>
											Select Role
										</option>
										{roles.map((option) => (
											<option key={option.user_roleid} value={option.user_roleid}>
												{option.role_name}
											</option>
										))}
									</select>
									{error.role_error && <p className="text-xs text-rose-200 mt-1">{error.role_error}</p>}
								</div>
							</form>
						</div>

						<div className="flex justify-center gap-2.5 px-5 py-3 border-t border-white/15 bg-white/[0.04]">
							<button
								type="button"
								onClick={handleClose}
								className="px-4 py-2 rounded-xl font-semibold text-white border border-white/25 transition hover:opacity-90"
								style={{ backgroundImage: "linear-gradient(90deg, #475569 0%, #334155 100%)" }}
							>
								Cancel
							</button>
							<button
								type="button"
								onClick={createUser}
								className="px-5 py-2 text-white font-semibold rounded-xl transition hover:opacity-90 border border-cyan-200/25"
								style={{
									backgroundImage:
										action === "Add"
											? "linear-gradient(90deg, #06b6d4 0%, #2563eb 100%)"
											: "linear-gradient(90deg, #0891b2 0%, #1d4ed8 100%)",
								}}
							>
								{action === "Add" ? "Add User" : "Update User"}
							</button>
						</div>
					</motion.div>
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default UserDialog;
